/** Stable placement keeps links reproducible without giving every question the same answer position. */
export function orderChoices<T extends { options: readonly string[]; answer: number }>(
  check: T,
  offset: number,
): Omit<T, 'options'> & { options: string[] } {
  const shift = ((offset % check.options.length) + check.options.length) % check.options.length;
  return {
    ...check,
    options: check.options.map(
      (_, index) => check.options[(index - shift + check.options.length) % check.options.length],
    ),
    answer: (check.answer + shift) % check.options.length,
  };
}
